module.exports = __webpack_public_path__ + "static/media/mathworks.22828bec.png";